import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=46e732ac"
import script from "./GroupDetails.vue?vue&type=script&lang=ts"
export * from "./GroupDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e732ac')) {
      api.createRecord('46e732ac', component.options)
    } else {
      api.reload('46e732ac', component.options)
    }
    module.hot.accept("./GroupDetails.vue?vue&type=template&id=46e732ac", function () {
      api.rerender('46e732ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupDetails.vue"
export default component.exports